import * as React from 'react';
import { ResourceEntityState, ResourceEntityStateConfigMap } from "../../../../../store/ResourcesListStore";

export class StateInEntityView extends React.Component<{ state?: ResourceEntityState }> {
    render() {
        const { state } = this.props;
        const config = state === undefined ? undefined : ResourceEntityStateConfigMap[state];
        return (
            <div className="resource-status">
                <div className={`align-center status ${config ? config.cssClassName : ''}`}>
                    {config ? config.title : state}
                </div>
            </div>
        );
    }
}
